module.exports = __webpack_public_path__ + "static/media/logo-black.7ddf9c92.png";